import { useTranslation } from "react-i18next"
import CommonUtil from "../../../utils/CommonUtil"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

const bookItems = [
    { title: 'instruction_firmware', type: 'hardware' },
    { title: 'instruction_use_book', type: 'use_book' },
    // { title: 'instruction_use_book_base', type: 'use_book_base' },
    // { title: 'instruction_fast_intro', type: 'fast_intro' },
]

const InstructionBook = props => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('instruction_book'))
        }
    }

    const handleOnClick = (type) => {
        switch (type) {
            case 'hardware':
                navigate('/hardware')
                break;
            case 'use_book':
                navigate('/use_book_single')
                break
            case 'use_book_base':
                navigate('/use_book')
                break
            case 'fast_intro':
                navigate('/fast_intro')
                break

            default:
                break;
        }
    }

    useEffect(() => {
        postTitle()
    }, [])

    return <div className="App" style={{ background: '#F6F7F8' }}>
        {
            bookItems.map((item, index) => {
                return <div key={index.toString()} className='instruction-item' onClick={() => {
                    handleOnClick(item.type)
                }}>
                    <span style={styles.itemText}>{t(item.title)}</span>
                    <img src={`${CommonUtil.getSourceDomain()}item_next_img.png`} alt="" style={styles.itemIcon} />
                </div>
            })
        }
    </div>
}

const styles = {
    itemText: {
        marginLeft: 15,
        color: '#000000CC',
        fontSize: 14,
        fontWeight: '500'
    },
    itemIcon: {
        width: 24,
        height: 24,
        marginRight: 15
    },
}

export default InstructionBook